import { semanticThemeTokens } from "@appretio/ui-kit";
import { RowClassParams } from "ag-grid-enterprise";
import { TopTenResponse } from "../../../pages/inSeasonReviewPage/hooks/useFetchTopTen";

/**
 * Determines row styling for cross-table rank comparison
 *
 * Styling Rules:
 * - Same rank in both tables → Green (match)
 * - Different rank in both tables → Yellow (shift)
 * - Not in other table → Transparent (no color)
 *
 * @param currentRowData - Current row being rendered
 * @param otherTableData - All rows from the comparison table
 * @returns Style object or undefined
 */

export function getRowStyleForCrossTableComparison(
  params: RowClassParams,
  otherTableData: TopTenResponse[]
) {
  if (!params.data) {
    return undefined;
  }

  const currentRow = params.data;
  const currentRank = currentRow.computedRank;

  // Find the same item in the other table
  const matchingRowInOtherTable = otherTableData.find(
    (row) => row.style_option_id_mockup === currentRow.style_option_id_mockup
  );

  if (!matchingRowInOtherTable) {
    // Item not in the other table - no color/transparent
    return undefined;
  }

  const otherRank = matchingRowInOtherTable.computedRank;

  // Same position (rank) in both grids
  if (currentRank === otherRank) {
    return {
      backgroundColor:
        semanticThemeTokens.dataTable.row.crossTableRowStyle.match
    };
  }

  // In both tables, but different position
  return {
    backgroundColor: semanticThemeTokens.dataTable.row.crossTableRowStyle.shift
  };
}
